var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jds-p-4 jds-border jds-border-grey-400 jds-rounded code-container"},[_c('div',[_c('pre',[_c('code',{staticClass:"jds-whitespace-pre-line"},[_vm._t("default")],2)])])])}
var staticRenderFns = []

export { render, staticRenderFns }